import {
  MentorType,
  MenteeType,
  MenteesType,
  MentorsType,
  AdminType,
  selectedTheme,
  itemTitlePlural,
  itemTitle,
  EventManagerType,
  EventManagersType,
  VolunteersType,
  user,
  VolunteerType,
  getMemberUserTabLabel,
  memberTabKeyToUrlParam,
  resolveMemberTabKey,
} from "../../utils/constant";

export const requestPageBreadcrumbs = {
  program_new: "new_program_request",
  program_reschedule: "program_reschedule",
  program_cancel: "program_cancel",
  program_mentee_cancel: "program_mentee_cancel",
  program_join: "program_join",
  member_join_request: "member_join_request",
  all_users: "all_users",
  testimonial_request: "testimonial_request",
  testimonial_request_admin_my: "testimonial_request_admin_my",
  report_request: "report_request",
  mentee: MenteeType.toLowerCase(),
  mentor: MentorType.toLowerCase(),
  program_join_request_admin: "program_join_request_admin",
  main_mentee_tab: "mentee_tab",
  main_admin_test_tab: "my_tab",
  adminReportTab: "all",
  adminApproveReportTab: "approved",
  adminCancelReportTab: "rejected",
  adminMemberMentorTab: MentorType.toLowerCase(),
  adminMemberMenteeTab: MenteeType.toLowerCase(),
  feed: "fead",
  dashboardfeed: "dashBoardfead",
  myMentee: "myMentee",
  newFollowRequest: "new_follow_request",
  myMentor: "myMentor",
  topMentor: "topMentor",
  newFollowRequestMentor: "new_follow_request_mentor",
  menteeAllReport: "all",
  menteeNewReport: "new",
  menteePendingReport: "pending",
  menteeCompletedReport: "approved",
  menteeRejectedReport: "rejected",
  menteeDraftReport: "draft",
  taskMenteeAllReport: "all",
  taskMenteeNewReport: "newtask",
  taskMenteeWaitReport: "waiting_for_approval",
  taskMenteeReassignedReport: "reassigned",
  taskMenteePendingReport: "pending",
  taskMenteeCompletedReport: "completed",
  taskMenteeRejectedReport: "rejected",
  taskMenteeDraftReport: "draft",
  dashboardPrograms: "dashboardProgramDetails",
  ticketHistorys: "ticketHistoryView",
  dashboardProgramsCard: "dashboardProgramscard",
  ProgramsCard: "programscard",
  ProgramsDetails: "programDetails",
  programDetailsProfileLCA: "programDetailsProfileLCA",
  dashboardtopmentor: "dashboardtopmentor",
  dashboardMemberMentor: "dashboardMemberMentor",
  dashboardMemberMentee: "dashboardMemberMentee",
  dashboardMemberUsers: "dashboardMemberUsers",
  ticketAll: "all",
  ticketNew: "new",
  ticketPending: "pending",
  ticketInprogress: "in_progress",
  ticketClosed: "closed",
  ticketResolved: "resolved",
  ticketReject: "rejected",
  mentorAllEditReport: "all",
  mentorNewEditReport: "new",
  mentorPendingEditReport: "pending",
  mentorDraftEditReport: "draft",
  mentorDashboardProgram: "mentorDashboardProgram",
  adminMemberChat: "adminMemberchat",
  menteesProfileCounts: "menteesProfileCount",
  dashboardRecentMembers: "dashboardRecentMembers",
  newMenteeQuestions: "newMenteeQuestions",
  createNewusers: "createNewUser",
  edit_user: "edit_user",
  topPrograms: "top_programs",
  timesheet: "timesheet",
  category: "category",
  draft_insights: "draft",
  paymentPageBack: "paymenttoprogram",
  task_profile_view: "task_details",
  prerequist: "prerequestBack",
  members: "members",
  equipment: "equipment",
  // navbarProfile : 'navbarProfile',
};
// export const programStatusBreadcrumbs = [
//   // 'All Programs',
//   "Total Programs",
//   "My Programs",
//   "Recently Joined Programs",
//   "Ongoing Programs",
//   "Assigned Programs",
//   "Active Programs",
//   `${AdminType} Assigned Programs`,
//   "Draft Programs",
//   "Bookmarked Programs",
//   "Upcoming Programs",
//   "Interested Programs",
//   "Rescheduled Programs",
//   "Completed Programs",
//   "Cancelled Programs",
// ];

export const programStatusBreadcrumbs = () => {
  
    return [
      // 'All Programs',
      `Total ${itemTitlePlural}`,
      `My ${itemTitlePlural}`,
      `Recently Joined ${itemTitlePlural}`,
      `Ongoing ${itemTitlePlural}`,
      `Assigned ${itemTitlePlural}`,
      `Active ${itemTitlePlural}`,
      `${AdminType} Assigned ${itemTitlePlural}`,
      `Draft ${itemTitlePlural}`,
      `Bookmarked ${itemTitlePlural}`,
      `Upcoming ${itemTitlePlural}`,
      `Interested ${itemTitlePlural}`,
      `Rescheduled ${itemTitlePlural}`,
      `Completed ${itemTitlePlural}`,
      `Cancelled ${itemTitlePlural}`,
    ];
  
};

//From Equipment Breadcrumb
export const equipmentBreadCrumbs = (name) => {
  return [
    {
      label: "Mobile Unit",
      path: -1,
    },
    {
      label: `${name}`,
    },
  ];
};

// Payment page back Params
export const patmentTOProgramPage = (name, is_event = false) => {
  return [
    {
      label:
        is_event && selectedTheme === "lca"
          ? "Event Details"
          : `${itemTitle} Details`,
      path:
        is_event && selectedTheme === "lca"
          ? "/events?type=planned&is_event=true&page=1"
          : "/programs?type=planned",
    },
    {
      label: `View ${name}`,
    },
  ];
};
// Program Request
export const request_newProgramRequest = (name, is_event = false) => {
  return [
    {
      label:
        is_event && selectedTheme === "lca"
          ? "Events Requests"
          : `${itemTitle} Requests`,
      path: "/all-request?type=program_request",
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const request_programReschedule = (name, is_event = false) => {
  return [
    {
      label:
        is_event && selectedTheme === "lca" ? "My Events" : `My ${itemTitle}`,
      path: `programs?type=yettojoin&programView=list&program_type=training_program`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const request_programCancel = (name, is_event = false) => {
  return [
    {
      label:
        is_event && selectedTheme === "lca"
          ? "Cancelled Events"
          : `Cancelled ${itemTitle}`,
      path: `/programs?type=cancelled`, //`/all-request?type=program_request&tabType=${requestPageBreadcrumbs?.program_cancel}`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const request_programMenteeCancel = (name) => {
  return [
    {
      label: "Cancellation Requests",
      path: `/all-request?type=program_request&tabType=${requestPageBreadcrumbs?.program_cancel}&mainTab=${requestPageBreadcrumbs.main_mentee_tab}`,
    },
    {
      label: `View ${name}`,
    },
  ];
};

// Program
export const program_details = (state, name) => {
  return [
    {
      label: state === "category" ? "Category View" : `${itemTitle} Details`,
      path: state === "category" ? -1 : "/programs?programView=grid",
    },
    {
      label: `${name}`,
    },
  ];
};
export const event_details = (name) => {
  return [
    {
      label: "Total Events",
      // path: -1,
      path: "/programs?program_type=field_session&page=1",
    },
    {
      label: `${name}`,
    },
  ];
};

export const recurring_event_details = (
  parentEventName,
  childEventName,
  parentPath
) => [
  {
    label: parentEventName || "Event",
    path: parentPath,
  },
  {
    label: childEventName,
  },
];

export const sub_event_details = (event_name, sub_event_name, program_id) => {
  return [
    {
      label : `${event_name}`,
      path: `/program-details/${program_id}`,
    }, 
    {
       label: `${sub_event_name}`,
    }
  ]
}

export const top_Programs = (name, is_event = false) => {
  return [
    {
      label:
        is_event && selectedTheme === "vms"
          ? "Top Events"
          : `Top ${itemTitle + "s"}`,
      path: -1,
    },
    {
      label: name,
    },
  ];
};

// Member Join Request

export const request_memberJoin = ({ role, userRole }) => {
  return [
    //   {
    //     label: "Requests",
    //     path: `/all-request`,
    //   },+
    {
      label: role === "admin" ? "Request Approval" : "Home",
      path:
        role === "admin"
          ? `/all-request?type=member_join_request`
          : "/dashboard?type=yettojoin",
    },
    {
      label: `${
        userRole ?? "User"
      } Profile`,
    },
  ];
};

// All Users

export const all_users = (role, membersTab) => {
  const userRole = (role || "").toLowerCase();
  const tabKey = resolveMemberTabKey(userRole, membersTab);
  return [
    {
      label: getMemberUserTabLabel(userRole, membersTab),
      path: `/members?tab=${memberTabKeyToUrlParam(tabKey)}`,
    },
    {
      label: "Profile",
    },
  ];
};

// Goal Request

export const request_goalMentor = (name, menteeQuery) => {
  const query = menteeQuery
    ? `&tabType=${requestPageBreadcrumbs?.mentor}&mainTab=${requestPageBreadcrumbs.main_mentee_tab}`
    : "";
  return [
    {
      label: "Goal Requests",
      path: `/all-request?type=goal_request${query}`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const request_goalMentee = (name, menteeQuery) => {
  const query = menteeQuery
    ? `&mainTab=${requestPageBreadcrumbs.main_mentee_tab}`
    : "";
  return [
    {
      label: "Goal Requests",
      path: `/all-request?type=goal_request&tabType=${requestPageBreadcrumbs?.mentee}${query}`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const request_goalNew = (name, menteeQuery) => {
  return [
    {
      label: "Goal Requests",
      path: `/all-request?type=new_goals_request`,
    },
    {
      label: `View ${name}`,
    },
  ];
};

// Testimonials Requests
export const request_testimonial = (name) => {
  return [
    {
      label: "Testimonial Requests",
      path: `/all-request?type=testimonial_request`,
    },
    {
      label: `View Testimonials`,
    },
  ];
};
export const request_testimonial_admin = (name) => {
  return [
    {
      label: "Testimonial Requests",
      path: `/all-request?type=testimonial_request&mainTab=${requestPageBreadcrumbs.main_admin_test_tab}`,
    },
    {
      label: `View Testimonials`,
    },
  ];
};

// Report Request

export const request_report = (name) => {
  return [
    {
      label: "Insight Requests",
      path: `/all-request?type=report_request`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
//Draft Insights
export const draft_insights = (name) => {
  return [
    {
      label: "Draft insights",
      path: -1,
    },
    {
      label: `View ${name}`,
    },
  ];
};

// Program Join Request

export const request_join = (name) => {
  return [
    {
      label: "Join Requests",
      path: `/all-request?type=program_request&tabType=${requestPageBreadcrumbs?.program_join}&mainTab=${requestPageBreadcrumbs.main_mentee_tab}`,
    },
    {
      label: name ? `View ${name}` : `View ${MenteeType} Profile`,
    },
  ];
};

export const default_breadcrumbs_for_report = (name) => {
  return [
    {
      label: "All Insights",
      path: `/reports`,
    },
    {
      label: name ? `View ${name}` : `View ${MenteeType} Profile`,
    },
  ];
};

// Admin Report
export const admin_report = (name) => {
  return [
    {
      label: "Reports",
      path: `/reports`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const admin_Approvedreport = (name) => {
  return [
    {
      label: "Approved Reports",
      path: `/reports?type=${requestPageBreadcrumbs?.adminApproveReportTab}`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const admin_Canceledreport = (name) => {
  return [
    {
      label: "Cancelled Insights",
      path: `/reports?type=${requestPageBreadcrumbs?.adminCancelReportTab}`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const admin_Allreport = (name) => {
  return [
    {
      label: "All Insights",
      path: -1,
    },
    {
      label: `View ${name}`,
    },
  ];
};
// Mentor Report
export const mentor_allreport = (name) => {
  return [
    {
      label: "All Insights",
      path: `/reports`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const mentor_Newreport = (name) => {
  return [
    {
      label: "New Insights",
      path: `/reports?tabType=${requestPageBreadcrumbs?.menteeNewReport}`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const mentor_Pendingreport = (name) => {
  return [
    {
      label: "Pending Insights",
      path: `/reports?tabType=${requestPageBreadcrumbs?.menteePendingReport}`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const mentor_Completedreport = (name) => {
  return [
    {
      label: "Completed Insights",
      path: `/reports?tabType=${requestPageBreadcrumbs?.menteeCompletedReport}&tr=fsdbj`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const mentor_Rejectedreport = (name) => {
  return [
    {
      label: "Rejected Insights",
      path: `/reports?tabType=${requestPageBreadcrumbs?.menteeRejectedReport}`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const mentor_Draftreport = (name) => {
  return [
    {
      label: "Draft Insights",
      path: `/reports?tabType=${requestPageBreadcrumbs?.menteeDraftReport}`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
//Mentor Edit Report
export const mentor_edit_allreport = (name) => {
  return [
    {
      label: "All Insights",
      path: `/reports`,
    },
    {
      label: `${name}`,
    },
  ];
};
export const mentor_edit_newreport = (name) => {
  return [
    {
      label: " New Insights",
      path: `/reports?type=${requestPageBreadcrumbs?.mentorNewEditReport}`,
    },
    {
      label: `${name}`,
    },
  ];
};
export const mentor_edit_pendingreport = (name) => {
  return [
    {
      label: "Pending Insights",
      path: `/reports?type=${requestPageBreadcrumbs?.mentorPendingEditReport}`,
    },
    {
      label: `${name}`,
    },
  ];
};
export const mentor_edit_draftreport = (name) => {
  return [
    {
      label: "Draft Insights",
      path: `/reports?type=${requestPageBreadcrumbs?.mentorDraftEditReport}`,
    },
    {
      label: `${name}`,
    },
  ];
};


// Member List
export const admin_mentorMember = (name) => {
  return [
    {
      label: "Users",
      path: `/members`,
    },
    {
      label: `User Profile`,
    },
  ];
};
export const admin_menteeMember = (name) => {
  return [
    {
      label: "Users",
      path: `/members`,
    },
    {
      label: `User Profile`,
    },
  ];
};

// Program Details Page
export const program_details_main = (name, statusName, NavigateTo) => {
  return [
    {
      label: `${statusName}`,
      path: NavigateTo,
    },
    {
      label: `${name}`,
    },
  ];
};
export const dashboard_program_details_main = (name, statusName) => {
  return [
    {
      label: `Home`,
      path: "/dashboard", // Corrected: Use string instead of navigate function
    },
    {
      label: `${name}`,
    },
  ];
};

// Feed

export const user_feed = (name) => {
  return [
    {
      label: `Feeds`,
      path: -1,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const dashboard_feed = (name) => {
  return [
    {
      label: `Home`,
      path: "/dashboard",
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const user_Defaultfeed = (name) => {
  return [
    {
      label: `Home`,
      path: `/dashboard`,
    },
    {
      label: `View ${name}`,
    },
  ];
};

// Mentee Nav tab

export const myMneteePage = (role) => {
  return [
    {
      label: `My ${role === user.mentor ? MenteesType : VolunteersType }`,
      path: `/mentees?req=my-mentee`,
    },
    {
      label: `View ${role === user.mentor ? MenteeType : VolunteerType } Profile`,
    },
  ];
};
export const newFollowRequestPage = (status) => {
  return [
    {
      label: `Follow Requests`,
      path: `/mentees?req=new-request-mentees&status=${status}`,
    },
    {
      label: `View ${MenteeType} Profile`,
    },
  ];
};


export const myMenteePage = () => {
  return [
    {
      label: `My ${MenteeType}s`,
      path: `/mentees`,
    },
    {
      label: `View ${MenteeType} Profile`,
    },
  ];
};
export const topMentorPage = (role,userRole) => {
  return [
    {
      label: `Top ${userRole === user.admin ? role :   [user.mentee, user.mentor].includes(userRole) ? MentorsType : EventManagersType}`,
      path: -1,
    },
    {
      label: ` ${userRole === user.admin ? role : [user.mentee, user.mentor].includes(userRole) ? MentorType : EventManagerType} Profile`,
    },
  ];
};

export const dashboardTopprograms = () => {
  return [
    {
      label: `Home`,
      path: "/dashboard",
    },
    {
      label: `View Top ${itemTitlePlural}`,
    },
  ];
};



export const goal_program_details = (name) => {
  return [
    {
      label: `${itemTitle} Detail`,
      path: -1,
    },
    {
      label: `View ${name}`,
    },
  ];
};

// Assignment

export const viewTasksDetails = (name, taskName) => {
  return [
    {
      label: `All Assignments`,
      path: "/mentor-tasks?type=menteetask",
    },
    {
      label: `${name}`,
      path: -1,
    },
    {
      label: `View ${taskName}`,
    },
  ];
};

// Program Completion Page
export const programCompletionPage = (name, is_event = false) => {
  return [
    {
      label: is_event ? "Events" : `${itemTitlePlural}`,
      path: `/programs${is_event ? "?is_event=true" : ""}`,
    },
    {
      label: `${name}`,
      path: -1,
    },
    {
      label: `Completed`,
    },
  ];
};
// Category View

export const categoryMentee = (name) => {
  return [
    {
      label: "Category",
      path: `/category`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const categoryMentor = (name) => {
  return [
    {
      label: "Category",
      path: `/category`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
export const categoryProgramList = (name) => {
  return [
    {
      label: "Category",
      path: `/category`,
    },
    {
      label: `View ${name}`,
    },
  ];
};
// Tickets History View
export const ticketHistoryView = (name) => {
  return [
    {
      label: "History",
      path: -1,
    },
    {
      label: `View New Ticket`,
    },
  ];
};

export const tabQuertyData = (role, tab) => {
  if (role === "admin") {
    return requestPageBreadcrumbs[tab];
  }
};
export const tabQuertyDataMentor = (role, tab) => {
  if (role === "mentor") {
    return requestPageBreadcrumbs[tab];
  }
};

export const programProfileBreadCrumb = () => {
  return [
    {
      label: `${itemTitle}`,
      path: `/programs`,
    },
    {
      label: `View ${MenteeType} Profile`,
    },
  ];
};
export const programcardDashBoard = () => {
  return [
    {
      label: `Home`,
      path: "/dashboard",
    },
    {
      label: `View Profile`,
    },
  ];
};
export const programcardProgrampage = () => {
  return [
    {
      label: `${itemTitle}`,
      path: -1,
    },
    {
      label: `View Profile`,
    },
  ];
};
export const programDetailsProfile = () => {
  return [
    {
      label: `${itemTitle} Details`,
      path: -1,
    },
    {
      label: `View Profile`,
    },
  ];
};

export const programDetailsProfileLCA = (is_event) => {
  return [
    {
      label:
        is_event && selectedTheme === "lca"
          ? `Event Details`
          : `${itemTitle} Details`,
      path: -1,
    },
    {
      label: `View Profile`,
    },
  ];
};

export const topmentorDashBoard = () => {
  return [
    {
      label: `Home`,
      path: "/dashboard?type=yettojoin",
    },
    {
      label: `View Profile`,
    },
  ];
};

export const memberMentorDashBoard = () => {
  return [
    {
      label: `Home`,
      path: "/dashboard",
    },
    {
      label: `${MentorType}s`,
    },
  ];
};
export const memberMenteeDashBoard = () => {
  return [
    {
      label: `Home`,
      path: -1,
    },
    {
      label: `${MenteeType}s`,
    },
  ];
};
export const memberUsersDashBoard = () => {
  return [
    {
      label: `Home`,
      path: -1,
    },
    {
      label: `Users`,
    },
  ];
};

// export const navbarProfile = () => {
//   return [
//     {
//       label: `Dashboard`,
//       path: -1,
//     },
//     {
//       label: `Profile`,
//     },
//   ];
// };

//mentor dashboard program
export const request_mentor_dashboardprogram = (name, type, typeLabel) => {
  const path = type ? `/dashboard?type=${type}` : `/dashboard`; // Fallback if type is null

  return [
    {
      label: typeLabel, // Correct label
      path: path, // Dynamic path with fallback
    },
    {
      label: `View ${name}`,
    },
  ];
};

//Admin Member Chat

export const adminMemberChat = (name) => {
  return [
    {
      label: "Members",
      path: `/members`,
    },
    {
      label: `View Messages`,
    },
  ];
};

export const menteesProfileCounts = (from) => {
  return [
    {
      label: `${
        from === "field_session" ? VolunteersType : MenteesType
      } Joined`,
      path: -1,
    },
    {
      label: `Profile`,
    },
  ];
};

export const timesheetBreadCrumbs = () => {
  return [
    {
      label: `${itemTitle} Timesheet`,
      path: -1,
    },
    {
      label: `Profile`,
    },
  ];
};
export const categoryViewBreadCrumbs = () => {
  return [
    {
      label: "Category",
      path: -1,
    },
    {
      label: "Profile",
    },
  ];
};
// Assignment Profile page
export const taskProfileViewBreadCrumbs = () => {
  return [
    {
      label: "Assignment Details",
      path: -1,
    },
    {
      label: "Profile",
    },
  ];
};

//dashboard recent members
export const dashboard_recent_members = () => {
  return [
    {
      label: "Home",
      path: -1,
    },
    {
      label: `Member Requests`,
    },
  ];
};

//new mentee questions
export const new_mentee_questions = () => {
  return [
    {
      label: `My ${itemTitlePlural}`,
      path: -1,
    },
    {
      label: `Questions`,
    },
  ];
};
//create new user
export const new_user_create = () => {
  return [
    {
      label: "User",
      path: -1,
    },
    {
      label: `Create New User`,
    },
  ];
};

//edit user
export const edit_user = (role, options = {}) => {
  const {
    editFrom,
    userId,
    memberStatus,
    profileBreadcrumbsType,
    membersTab,
    fromProfile,
  } = options || {};
  const userRole = (role || "").toLowerCase();

  if (fromProfile) {
    return [
      {
        label: "Profile",
        path: "/profile",
      },
      {
        label: "Edit Profile",
      },
    ];
  }

  if (editFrom === "profile" && userId) {
    const query = new URLSearchParams();
    if (memberStatus) query.set("member_status", memberStatus);
    if (profileBreadcrumbsType) {
      query.set("breadcrumbsType", profileBreadcrumbsType);
    }
    if (userRole) query.set("role", userRole);
    if(membersTab) query.set("membersTab", membersTab);

    const queryString = query.toString();

    return [
      {
        label: "Profile",
        path: `/mentor-details/${userId}${queryString ? `?${queryString}` : ""}`,
      },
      {
        label: "Edit Profile",
      },
    ];
  }

  const tabKey = resolveMemberTabKey(userRole, membersTab);

  return [
    {
      label: getMemberUserTabLabel(userRole, membersTab),
      path: `/members?tab=${memberTabKeyToUrlParam(tabKey)}`,
    },
    {
      label: "Edit Profile",
    },
  ];
};

export const timeSheetProgram = (
  name,
  is_event = false,
  programId,
  query = {}
) => {
  const params = new URLSearchParams();

  Object.entries(query || {}).forEach(([key, value]) => {
    if (
      value == null ||
      value === "" ||
      key === "program_id"
    ) {
      return;
    }
    params.set(key, String(value));
  });

  if (is_event) {
    if (!params.has("is_event")) params.set("is_event", "true");
    if (!params.has("from")) params.set("from", "event");
  }

  const queryString = params.toString();
  const detailsPath = programId
    ? `/program-details/${programId}${queryString ? `?${queryString}` : ""}`
    : -1;

  return [
    {
      label: name,
      path: detailsPath,
    },
    {
      label: is_event ? "Event Timesheet" : `${itemTitle} Timesheet`,
    },
  ];
};

export const deploymentScreenNavigation = () => {
  return [
    {
      label: "Home",
      path: "/dashboard?type=yettojoin",
    },
    {
      label: `${itemTitle} details`,
      path: -1,
    },
    {
      label: "Deployment",
    },
  ];
};

// Feed back Breadcrumbs

export const feedBackBreadCrumbs = () => {
  return [
    {
      label: "Home",
      path: "/dashboard?type=yettojoin",
    },
    {
      label: "FeedBack",
    },
  ];
};
// Prerequies popup back Breadcrumbs

export const prequesBackPage = () => {
  return [
    {
      label: `${itemTitle} Details`,
      path: -1,
    },
    {
      label: "Profile",
    },
  ];
};

//equipment

export const equipment_BreadCrams = (name) => {
  return [
    {
      label: `Mobile Units`,
      path: '/equipment',
    },
    {
      label: `${name}`,
    },
  ];
};
export const equipment_history = (name) => {
  return [
    {
      label: `Mobile Units`,
      path: '/equipment',
    },
    {
      label: `${name}`,
    },
  ];
};
export const equipment_Default = (name) => {
  return [
    {
      label: `Mobile Units`,
      path: '/equipment',
    },
    {
      label: `${name}`,
    },
  ];
};
export const equipment_track = (name) => {
  return [
    {
      label: `Mobile Unit`,
      path: -1,
    },
    {
      label: `Track`,
      path: `/equipment`,
    },
    {
      label: `${name}`,
    },
  ];
};
export const bulkUpload = (parentLabel = "Home") => {
  return [
    {
      label: parentLabel,
      path: -1,
    },
    {
      label: `BulkUpload`,
    },
  ];
};

export const auditLogs = () => {
  return [
    {
      label: "Home",
      path: "/dashboard",
    },
    {
      label: "Audit Logs",
    },
  ];
};

export const menteeOnboardingView = () => {
  return [
    {
      label: "Applications",
      path: "/admin-requests?request_type=onboarding&role=mentee",
    },
    {
      label: `Mentee Application Details`,
    },
  ];
};
